import { useEffect, useState } from "react";
import { Modal, MuniSpinner2, Table } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { constanciaAnulacionHandler } from "../../../handlers/opciones.handler";

const ModalConstanciaAnular = () => {
  const { loads, modals, handlerModal } = useGeneralAppStore();
  const { actaDetalle, acta } = useActaDetalleStore();


  const [constancia, setConstancia] = useState();

  useEffect(() => {
    constanciaAnulacionHandler({ id: acta?.id }, setConstancia);
  }, []);

  return (
    <>
      <Modal
        show={modals.includes("constancia_anulacion")}
        size={'xl'}
        onHide={() => handlerModal({ modal: false, modalName: "constancia_anulacion" })}
        title={() =>
          `Constancia de anulación`
        }
      >
        {loads.includes("constancia_anulacion") ? (
          <MuniSpinner2 />
        ) : (
          <>
            {
              constancia
                ?
                <div className="bg-white w-100">
                  <object data={constancia?.file} type="application/pdf" className="w-100 " style={{ aspectRatio: "3/4" }} />
                </div>
                :

                <div className="bg-white w-100">
                  <p className="text-danger text-center fw-bold my-5">No hay constancia de anulación</p>
                </div>
            }
          </>
        )}
      </Modal>
    </>
  );
};
export default ModalConstanciaAnular;
